import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const themes = {
  default: {
    name: 'Varsayılan',
    icon: '🔵',
    sidebar: 'linear-gradient(180deg, #1e3a5f 0%, #2d5a87 100%)',
    sidebarHover: 'rgba(255,255,255,0.1)',
    sidebarActive: 'rgba(255,255,255,0.2)',
    primary: '#3b82f6',
    primaryHover: '#2563eb',
    accent: '#F7941D',
  },
  corporate: {
    name: 'Kurumsal',
    icon: '🟡',
    sidebar: 'linear-gradient(180deg, #00296B 0%, #003F88 100%)',
    sidebarHover: 'rgba(253,197,0,0.15)',
    sidebarActive: 'rgba(253,197,0,0.25)',
    primary: '#00509D',
    primaryHover: '#003F88',
    accent: '#FDC500',
  },
  dark: {
    name: 'Karanlık',
    icon: '🌙',
    sidebar: 'linear-gradient(180deg, #1a1a2e 0%, #16213e 100%)',
    sidebarHover: 'rgba(255,255,255,0.1)',
    sidebarActive: 'rgba(255,255,255,0.2)',
    primary: '#6366f1',
    primaryHover: '#4f46e5',
    accent: '#f59e0b',
  }
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('erp-theme');
    return saved && themes[saved] ? saved : 'default';
  });

  useEffect(() => {
    localStorage.setItem('erp-theme', theme);
    
    const root = document.documentElement;
    const t = themes[theme];
    
    root.style.setProperty('--sidebar-bg', t.sidebar);
    root.style.setProperty('--sidebar-hover', t.sidebarHover);
    root.style.setProperty('--sidebar-active', t.sidebarActive);
    root.style.setProperty('--primary', t.primary);
    root.style.setProperty('--primary-hover', t.primaryHover);
    root.style.setProperty('--accent', t.accent);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, currentTheme: themes[theme] }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
}
